import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { Gauge, Medal, TrendingUpDown, UserRound } from "lucide-react";
import React, { useEffect, useState } from "react";
import { getTrainingBoot } from "services/aquatic/aquatic-service";
import {
  ColumnsUserAquaBoot,
  ColumnsUserCmj,
  ColumnsUserComparationAqua,
} from "../load-control/columns-table";
import { FONT, ROLE_USER, USER_STORAGE} from "constants/index";
import { notificationErroInternal, notificationInfo, notificationSucessMsg } from "util/api-utils";

import {
  chartBarOneLine,
  chartLinerDot,
} from "../load-control/load-control-drawer-charts";
import { getById } from "services/user/user-service";
import { resetPassword } from "services/login/login-service";

const { Text } = Typography;

const FormTrainningBootAqua = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [imgAvatar, setImgAvatar] = useState(null);
  const [userControl, setUserControl] = useState({});
  const [data, setDataDrawer] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [formRefNewPassword] = Form.useForm();

  useEffect(() => {
    if (user?.id) {
      setLoading(true);
      getData();
    }
  }, [user]);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id, role } = JSON.parse(localStorageItem);
      if (role == ROLE_USER) {
        getById(id).then((res) => {
          setIsModalOpen(res.shouldResetPassword);
        });
      }
    }
  }, [localStorage.getItem(USER_STORAGE)]);

  function getData() {
    getTrainingBoot(user?.id)
      .then((res) => {
        setUserControl(res);
        const dataResult = res.trainingGrouped?.map((obj) => ({
          ...obj,
          changeActualComp: changeActual,
        }));
        setDataDrawer(dataResult);
        setImgAvatar(res.img);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const changeActual = function (row) {
    setLoading(true);
    setTimeout(() => {
      let newUserSelected = userControl;
      newUserSelected.trainingActual = row;
      setUserControl(newUserSelected);
      setLoading(false);
    }, 300);
  };
  const handleCancel = () => {
    formRefNewPassword.resetFields();
    setIsModalOpen(false);
    setIsLoadingPassword(false);
  };

  const handleOk = () => {
    setIsLoadingPassword(true);
    formRefNewPassword
      .validateFields()
      .then((values) => {
        if (values.password != values.confirmPassword) {
          notificationInfo("As senhas devem ser iguais!");
          setIsLoadingPassword(false);
          return;
        }

        const request = {
          id: userControl.id,
          password: values.password,
        };
        resetPassword(request)
          .then(() => {
            notificationSucessMsg("Senha alterada com sucesso!");
            handleCancel();
          })
          .catch((err) => {
            setIsLoadingPassword(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde"
            );
          });
      })
      .catch((errors) => {
        setIsLoadingPassword(false);
        console.log(errors);
      });
  };

  return (
    <Spin size="large" spinning={loading}>
      <Row gutter={16} style={{ textAlign: "center", marginBottom: "30px" }}>
        <Col span={24}>
          <Avatar src={imgAvatar} icon={<UserRound size={120} />} size={120} />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Space direction="vertical" size={"small"}>
          <Card
            id="card-table"
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <Medal
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                    Histórico de Treinos
                  </Text>
                </div>
              </div>
            }
            bordered={false}
          >
            <Table
              columns={ColumnsUserComparationAqua()}
              dataSource={data}
              pagination={{ pageSize: 2, showSizeChanger: false }}
              locale={{
                emptyText: "Sem registro",
              }}
            />
          </Card>
        </Space>
      </Row>
      <Divider />
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={24} style={{ marginTop: "10px" }}>
          <Card
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <Gauge
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "14px", fontFamily: FONT }}>
                    Treinos
                  </Text>
                </div>
              </div>
            }
            style={{ width: "100%" }}
          >
            {chartBarOneLine(
              userControl.trainingActual?.training ?? [],
              "date",
              "load",
              "Metragem",
              "loadFinal",
              "Esforço",
              5
            )}
          </Card>
        </Col>
      </Row>
      <Divider />
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={24} style={{ marginTop: "10px" }}>
          <Card
            id="card-table"
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: 1 }}>
                  <TrendingUpDown
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                    Treinos
                  </Text>
                </div>
              </div>
            }
            bordered={false}
          >
            <Table
              columns={ColumnsUserAquaBoot()}
              dataSource={userControl.trainingActual?.training ?? []}
              pagination={{ pageSize: 5, showSizeChanger: false }}
              size="small"
              locale={{
                emptyText: "Sem registro",
              }}
            />
          </Card>
        </Col>
      </Row>
      <Divider />
      <Modal
        className="modal-password"
        style={{ textAlign: "center" }}
        title="Definir Nova Senha"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoadingPassword}
            onClick={handleOk}
          >
            Salvar
          </Button>,
        ]}
      >
        <Form
          form={formRefNewPassword}
          layout={"vertical"}
          style={{ maxWidth: 600, fontFamily: FONT }}
        >
          <Form.Item
            label="Senha"
            name="password"
            rules={[
              {
                required: true,
                message: "È necessário informar a senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirmar Senha"
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: "È necessário informar a confirmação de senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </Spin>
  );
};

export default FormTrainningBootAqua;
